import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import EventBus from "../../utils/EventBus";
import LEADAPI from "../../Api/lead";
import { toast } from "sonner";
import ASSIGNLEADAPI from "../../Api/assignLead";

export const fetchLeads = createAsyncThunk("lead/fetchleads", async (params, thunkAPI) => {
    try {
        const response = await LEADAPI.getLeads(params);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const addLead = createAsyncThunk("lead/addlead", async (formData, thunkAPI) => {
    try { 
        const response = await LEADAPI.addLead(formData);
        const message = response.message;
        thunkAPI.dispatch(setMessage(message));
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const updateLead = createAsyncThunk("lead/updatelead", async ({ l_id, formData }, thunkAPI) => {
    try {
        const response = await LEADAPI.updateLead(l_id, formData);
        const message = response.message;
        thunkAPI.dispatch(setMessage(message));
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const deleteLead = createAsyncThunk("lead/deletelead", async (l_id, thunkAPI) => {
    try {
        const response = await LEADAPI.deleteLead(l_id); // Corrected API call
        return l_id; // Return the lead id to remove from state
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const getLeadById = createAsyncThunk("lead/getleadbyid", async (l_id, thunkAPI) => {
    try {
        const response = await LEADAPI.getLeadById(l_id);
        console.log(response)
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const updateAssignLead = createAsyncThunk("leads/updateAssignLead", async ({ assignLeads_id, formData }, thunkAPI) => {
    try {
        const response = await ASSIGNLEADAPI.updateAssignLead(assignLeads_id, formData);
         const message=(response.message)
        
            thunkAPI.dispatch(setMessage(message))
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const createAssignLead = createAsyncThunk("leads/createAssignLead", async (formData, thunkAPI) => {
    try {
        const response = await ASSIGNLEADAPI.createAssignLead(formData);
         const message=(response.message)
        
            thunkAPI.dispatch(setMessage(message))
        console.log(response)
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const getAssignLeadById = createAsyncThunk("assignLead/getAssignLeadById", async (assignLeads_id, thunkAPI) => {
    try {
        const response = await ASSIGNLEADAPI.getAssignLeadById(assignLeads_id);
        console.log(response)
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
}); 
 
// Export Lead

// Lead as CSV
export const exportLeadAsCsv = createAsyncThunk("lead/exportLeadAsCsv", async (params, thunkAPI) => {
    try {
        const response = await LEADAPI.exportLeadAsCsv(params);
         const message=(response.message)
        
            thunkAPI.dispatch(setMessage(message))
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

// Lead as Excel
export const exportLeadAsExcel = createAsyncThunk("lead/exportLeadAsExcel", async (params, thunkAPI) => {
    try {
        const response = await LEADAPI.exportLeadAsExcel(params);

        console.log("Response Headers:", response.headers);
        console.log("Response Type:", response.data.type);
         const message=(response.message)
        
         thunkAPI.dispatch(setMessage(message))
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



// Import Lead
export const importLeads = createAsyncThunk("lead/importLeads", async (formData, thunkAPI) => {
    try { 
        const response = await LEADAPI.importLeads(formData);
        console.log(response)
         const message=(response.message)
        
        thunkAPI.dispatch(setMessage(message))
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});


const leadSlice = createSlice({
    name: "lead",
    initialState: {
        leads: [],
        leadDetails:"",
        totalCount: "",
        totalPages:""
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLeads.fulfilled, (state, action) => {
               
                state.leads = action.payload.data;
                state.totalCount = action.payload.totalCount;
            })
            .addCase(getLeadById.fulfilled, (state, action) => {
                // console.log(action.payload)
                state.leadDetails = action.payload; // Update state with a specific lead
            })
            .addCase(addLead.fulfilled, (state, action) => {
                state.leads.push(action.payload.data); // Add new lead to the list
            })
            .addCase(createAssignLead.fulfilled, (state, action) => {
                console.log("Created AssignLead", action.payload.data);
                state.leadDetails = action.payload.data;  
            })
            .addCase(updateLead.fulfilled, (state, action) => {
                // Update the specific lead in the array
                const {arg: { l_id }} = action.meta;
                if (l_id) {
                    state.leads = state.leads.map((item) =>
                        item._id === l_id ? action.payload : item
                    );
                }
                state.leadDetails = action.payload; 
            })
            .addCase(updateAssignLead.fulfilled, (state, action) => {
                console.log("AssignLead",action.payload);
                
                // Update the specific lead in the array
                console.log(action.payload);
                state.leadDetails = action.payload.data; 
            }) 
            .addCase(deleteLead.fulfilled, (state, action) => {
                // Remove the lead from the array using the id
                state.leads = state.leads.filter((lead) => lead.id !== action.payload);
            })

            // Lead as CSV
            .addCase(exportLeadAsCsv.fulfilled, (state, action) => {
                console.log(action)
                state.leads = action.payload.data;
                state.totalPages = action.payload.totalPages;
            })

            // Lead as Excel
            .addCase(exportLeadAsExcel.fulfilled, (state, action) => {
                console.log(action)
                state.leads = action.payload.data;
                state.totalPages = action.payload.totalPages;
            })

            // Import Lead
            .addCase(importLeads.fulfilled, (state, action) => {
                state.leads.push(action.payload.data); 
            })
    },
});

const { reducer } = leadSlice;
export default reducer;
